import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useUnityContext } from "../components/container/unityContainer";
import { RP_TYPE } from "../config/constant/unityConstants";
import { errorToast } from "../helpers/toastHelper";
import { canGenerateRenderOrPreview } from "../helpers/unity/canSaveProject";
import {
  toggleSidebarSection,
  selectIs2DMode,
} from "../redux/slicers/admin/curatorSlicer";
import { projectCameraAngleSelector } from "../redux/slicers/camera/projectCameraAngleSlicer";
import {
  selectPopupType,
  setOpen,
} from "../redux/slicers/camera/renderPreviewPoppupSlicer";
import { getAppState } from "../redux/store";
import { useUserContext } from "../contexts/UserContext";
import { Mixpanel, MxEvent } from "../common/Mixpanel";
import { getRoomDetailsApi } from "../api/curator";

export const useRenderPreviewPopup = () => {
  const { currentUser } = useUserContext();
  const dispatch = useDispatch();
  const { handleCameraPopupClose } = useUnityContext();

  const openPopup = async (type) => {
    console.log(currentUser);
    Mixpanel.track( true, 
      MxEvent.CURATOR_CREATE_IMAGE_POPUP_OPEN
    );
    const canGenerate = await canGenerateRenderOrPreview();
    if (!canGenerate) {
      return;
    }

    const is2DMode = selectIs2DMode(getAppState());

    if (is2DMode) {
      if (type === RP_TYPE.PREVIEW) {
        errorToast("Please switch to 3d view for creating previews", {
          toastId: "SWITCH_TO_3D_VIEW_FOR_PREVIEW",
        });
      } else {
        errorToast("Please switch to 3d view for creating render", {
          toastId: "SWITCH_TO_3D_VIEW_FOR_RENDER",
        });
      }

      return;
    }

    dispatch(setOpen(type));
    dispatch(toggleSidebarSection(null));
  };

  const closePopup = () => {
    // console.log(currentUser);
    Mixpanel.track( true, 
      MxEvent.CURATOR_CREATE_IMAGE_POPUP_CLOSED
    );
    dispatch(setOpen(false));
    handleCameraPopupClose?.();
  };

  const togglePopup = (type) => {
    const popupType = selectPopupType(getAppState());

    if (popupType === type) {
      closePopup();
    } else {
      openPopup(type);
    }
  };

  return {
    openPopup,
    closePopup,
    togglePopup,
  };
};
